import React, { FC } from 'react';
import { NavCustomerButton } from './customers/NavCustomerButton';
import { NavLoginButton } from './login/NavLoginButton';
import { NavPublicPricing } from './pricing/NavPublicPricing';
import { NavSignupButton } from './signup/NavSignupButton';
import { Nav } from './components/Nav';
import {
  NavPersonaJuriste,
  NavPersonaLawyer,
} from './personas/NavPersonasButtons';

export const NavPublic: FC = () => {
  return (
    <Nav dataTestId="nav-public">
      <NavPersonaLawyer />
      <NavPersonaJuriste />
      <NavCustomerButton />
      <NavPublicPricing />
      <NavLoginButton />
      <NavSignupButton />
    </Nav>
  );
};
